
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"50","viewBox":"0 0 50 50","width":"50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m24.1875 3c-.910156 0-1.855469.4375-2.625 1.21875l-11.625 11.59375c-.640625.566406-.9375 1.664063-.9375 2.4375v13.5c0 .765625.316406 1.859375.90625 2.375l11.59375 11.5625c1.054688 1.074219 2.027344 1.3125 2.65625 1.3125 1.667969 0 2.84375-1.523437 2.84375-3.6875v-37c0-2.277344-1.460937-3.3125-2.8125-3.3125zm-21.1875 12.96875c-1.675781 0-3.03125 1.355469-3.03125 3.03125v12c0 1.675781 1.355469 3.03125 3.03125 3.03125h4.46875c-.328125-.785156-.46875-1.621094-.46875-2.28125v-13.5c0-.65625.164063-1.488281.5-2.28125zm28.90625 3c-.042969.007813-.085937.019531-.125.03125-.375.066406-.675781.339844-.78125.703125-.105469.367188.003906.757813.28125 1.015625l4.28125 4.28125-4.28125 4.28125c-.398437.398438-.398437 1.039063 0 1.4375.398438.398438 1.039063.398438 1.4375 0l4.28125-4.28125 4.28125 4.28125c.398438.398438 1.039063.398438 1.4375 0 .398438-.398437.398438-1.039062 0-1.4375l-4.28125-4.28125 4.28125-4.28125c.324219-.300781.410156-.777344.214844-1.171875-.191406-.398437-.625-.617187-1.058594-.546875-.222656.023438-.433594.125-.59375.28125l-4.28125 4.28125-4.28125-4.28125c-.207031-.222656-.507812-.335937-.8125-.3125z"}})])
          )
        }
      }
    